import Link from 'next/link';

export interface ProductBreadcrumbsProps {
    paths: BreadcrumbLink[];
}

export interface BreadcrumbLink {
    href?: string;
    name: string;
}

export function ProductBreadcrumbs({ paths }: ProductBreadcrumbsProps): JSX.Element {
    return (
        <ol
            className={
                'flex flex-wrap gap-[10px] mt-[-200px] md:mt-[40px] pb-[20px] md:border-b-[1px] border-neutrals-200'
            }
        >
            {paths.map((link) => {
                return (
                    <li key={link.name}>
                        {link.href ? (
                            <>
                                <Link href={link.href} className={'text-brown-700 text-14'}>
                                    {link.name}
                                </Link>
                                <span className={'ml-[10px] text-14'}>/</span>
                            </>
                        ) : (
                            <span className={'text-14'}>{link.name}</span>
                        )}
                    </li>
                );
            })}
        </ol>
    );
}
